var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":'/category/'+_vm.routeName.toLowerCase()}},[_vm._v(_vm._s(_vm.routeName))]),(_vm.routeId != undefined)?_c('span',[_c('span',{staticClass:"space"},[_vm._v(">")]),_c('span',[_vm._v(_vm._s(_vm.routeId))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }